export default "__VITE_ASSET__52f57443__"